



















import { Component, Prop, Vue } from "vue-property-decorator";
import CzButton from "../cz/CzButton.vue";
import CzCard from "../cz/CzCard.vue";
import CzNotice from "../cz/CzNotice.vue";
import TextArea from "../form/textArea.vue";
import { ProgramPackTexts } from "../../bookings/programPackTexts";
import { GuidelineApi } from "./guidelineApi";

// The conversation with the team about one guideline: what the patient wrote and each answer, oldest first.
@Component({ components: { CzButton, CzCard, CzNotice, TextArea } })
export default class GuidelineChat extends Vue {
  @Prop({ default: 0 }) guidelineId!: number;
  // A closed guideline, or one without messages, keeps its past conversation to read.
  @Prop({ type: Boolean, default: false }) readonly!: boolean;

  messages: any[] = [];
  text = "";
  error = "";
  sending = false;

  async mounted() {
    await this.load();
  }

  async load() {
    const res = await GuidelineApi.messages(this.guidelineId);
    this.messages = res && res.ok ? res.model.slice().reverse() : [];
  }

  when(date: string): string {
    return date ? ProgramPackTexts.dateTime(date) : "";
  }

  async send() {
    if (this.sending) return;
    this.sending = true;
    this.error = "";
    const res = await GuidelineApi.sendMessage({ customerGuidelineId: this.guidelineId, text: this.text }).catch(() => null);
    this.sending = false;
    if (!res || !res.ok) {
      this.error = (res && res.errorMsg) || this.$t("It could not be sent. Try again").toString();
      return;
    }
    this.text = "";
    await this.load();
  }
}
